import { render } from "./FolderCard2.vue?vue&type=template&id=09b77e8a&scoped=true"
import script from "./FolderCard2.vue?vue&type=script&lang=js"
export * from "./FolderCard2.vue?vue&type=script&lang=js"

import "./FolderCard2.vue?vue&type=style&index=0&id=09b77e8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b77e8a"]])

export default __exports__